import React from "react";
import { join, reverse } from "lodash";
import styled from "styled-components";
import { shorten } from "@backpacker/number";
import { content, gradients } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { normalize } from "@tootools/number";
import { Variant, useColors } from "./colors";

const Container = styled.div`
  margin: 0 10px;
  height: 28px;
  display: flex;
  align-items: center;
`;

const Value = styled.span`
  font-size: 11px;
  color: ${content};
  fill: ${content};
`;

const BarContainer = styled.div`
  display: inline-block;
  position: relative;
  height: 10px;
  width: 80px;
  margin: 0 5px;
`;

const Bar = styled.div<{ colors: string[] }>`
  > div:last-child {
    position: absolute;
    height: 10px;
    width: 100%;
    bottom: 0;
    left: 0;
    border-radius: 5px;
    background: linear-gradient(
      to right,
      ${(props) => join(gradients(props.colors, 20), ",")}
    );
  }
`;

const Indicator = styled.div<{ left: number }>`
  position: absolute;
  top: -7px;
  left: calc(${(props) => props.left || 0}% - 5px);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 7px solid ${content};
  transition: 0.3s;
  opacity: ${(props) => (props.left !== null ? 1 : 0)};
`;

function getIndicatorLeft(
  value: number,
  maxValue: number,
  minValue: number,
  populations?: boolean
) {
  if (value) {
    return normalize(
      [0, 100],
      minValue,
      maxValue,
      value,
      !populations ? "lg" : null
    );
  } else {
    return null;
  }
}

interface IProps {
  value: number;
  minValue: number;
  maxValue: number;
  locale: Locale;
  variant: Variant;
  colors?: string[];
  populations?: boolean;
}

export default function FeaturesLegend({
  value,
  minValue,
  maxValue,
  locale,
  colors,
  variant,
  populations,
}: IProps) {
  const geoColors = useColors(variant, colors);
  return (
    <Container>
      <Value>{shorten(locale, minValue)}</Value>
      <BarContainer>
        <Indicator
          left={getIndicatorLeft(value, maxValue, minValue, populations)}
        />
        <Bar colors={reverse(gradients(geoColors, 20))}>
          <div />
        </Bar>
      </BarContainer>

      <Value>{shorten(locale, maxValue)}</Value>
    </Container>
  );
}
